
import React from 'react'
import {connect} from "react-redux";
import Titulo from "../../framework2/ej2/UI/Titulo";
import "../resources/css/formulario_responsive.css";
import PropTypes from "prop-types";
import {
    COMPONENTE_TIPO_DATE, COMPONENTE_TIPO_DATETIME,
    COMPONENTE_TIPO_FOREIGN, COMPONENTE_TIPO_FOREIGN_PANTALLA,
    COMPONENTE_TIPO_FOREIGN_SERVIDOR,
    COMPONENTE_TIPO_INPUT, COMPONENTE_TIPO_MEMO,
    COMPONENTE_TIPO_SELECT,
    guardar, postServicio,
    showSecciones,
} from "../utils/FormularioUtils";
import {citaavisoestados, tiposPagos} from "../utils/Definiciones";
import Pacientes from "../general/Pacientes";
import {getMinutosEntreDates, getMinutosEntreDatesSinAbs} from "../../framework2/ej2/utils/DateUtils";


class Cita extends React.Component {

    constructor(props) {
        super(props)
        this.state = {
            elemento: props.elemento,
        }

        this.elementoConfig= {
            className: "Cita",
            secciones: [
                {
                    titulo: "Datos ",
                    campos: [
                        {campo: "fechainicio", titulo: "Fecha inicio", tipo: COMPONENTE_TIPO_DATETIME, cols: 2, obligatorio: true,
                            onChange: (newCita) => {
                                    const duracion =
                                        new Date(this.state.elemento.fechafin).getTime() -
                                        new Date(this.state.elemento.fechainicio).getTime();
                                    return {
                                        ...newCita,
                                        fechafin: new Date(newCita.fechainicio + duracion)
                                    };
                            }
                        },
                        {campo: "fechafin", titulo: "Fecha fin", tipo: COMPONENTE_TIPO_DATETIME, fechaReadOnly:true, cols: 2, obligatorio: true,},

                        {campo: "pacienteCodigo", titulo: "Paciente", tipo: COMPONENTE_TIPO_FOREIGN_PANTALLA, cols: 3, obligatorio: true,
                            clase: 'com.ej2sistemas.dental.modelo.Paciente',
                            formulario: <Pacientes llamador="citas" />,
                            onChange: (newCita) => {
                                console.log ("Paciente Modificado");
                                console.log("newCita: ", newCita);
                                //!!!! MUY IMPORTANTE PQ 8NO SABEMOS POR QUÉ SE LANZA ESTE EVENTO CON EL PACIENTE SELECCIONADO COMO newCita AL REPINTAR
                                // POR ESO COMPROBAMOS QUE SEA LA PRIMERA LLAMADA CON LA CITA (Tiene el campo pacienteCodigo)
                                if (newCita && newCita.pacienteCodigo) {
                                    console.log("newCita.pacienteCodigo: ", newCita.pacienteCodigo);
                                    if (newCita.pacienteCodigo.doctorCodigo) {
                                        console.log("newCita.pacienteCodigo.doctorCodigo: ", newCita.pacienteCodigo.doctorCodigo);
                                        let newCitaModificada= {...newCita, doctorCodigo: newCita.pacienteCodigo.doctorCodigo}
                                        return newCitaModificada;
                                    }
                                }
                            }
                        },

                        {campo: "clinicaCodigo", titulo: "Clínica", tipo: COMPONENTE_TIPO_FOREIGN, valores: props.datosmaestros.clinicas, cols: 2, obligatorio: true},
                        {campo: "doctorCodigo", titulo: "Doctor", tipo: COMPONENTE_TIPO_FOREIGN, valores: props.datosmaestros.doctores, cols: 2, obligatorio: true},
                        {campo: "texto", titulo: "Notas", tipo: COMPONENTE_TIPO_MEMO, rows:3, cols: 4},
                        {campo: "avisoestado", titulo: "Aviso", tipo: COMPONENTE_TIPO_SELECT, valores:citaavisoestados, cols: 2},
                    ]
                },

            ]
        };
    }


    componentDidMount() {
    }

    setTab = (tabName) => {
        this.setState({activeTab: tabName});
    }

    addSalaEspera= (cita) => {
        const {elemento} = this.state;
        const {auth, estado} = this.props;
        let parametros= {
            usuarioCodigo: auth.usuarioCodigo,
            citaCodigo: elemento.codigo,
            clinicaCodigo: estado.clinica.codigo,
            destino:0,
        }
        postServicio(this, "Salaespera", "addSalaEspera", parametros, (resultado) => {
            console.log("Resultado: ", resultado);
            if (resultado && Boolean(resultado.exito))
                alert("Paciente en sala de espera");
        });
    }

    esCitaValida= (cita) => {
        console.log("COMPROBAR CITA");
        console.log("cita: ", cita);

        let dtFechaInicio = new Date(cita.fechainicio);
        let fechaInicioHora = dtFechaInicio.getHours();   // hora (0–23)
        let fechaInicioMinutos = dtFechaInicio.getMinutes(); // minutos (0–59)
        console.log("INICIO: Hora: ", fechaInicioHora, " Minutos: " + fechaInicioMinutos);
        
        if (fechaInicioHora < 8 ) {
            alert("Hora de inicio anterior a las 8:00am");
            return false;
        }

        if (fechaInicioHora >= 22) {
            alert("Hora de inicio superior a las 10:00pm");
            return false;
        }

        let dtFechaFin = new Date(cita.fechafin);
        let fechaFinHora = dtFechaFin.getHours();   // hora (0–23)
        let fechaFinMinutos = dtFechaFin.getMinutes(); // minutos (0–59)
        console.log("INICIO: Hora: ", fechaFinHora, " Minutos: " + fechaFinMinutos);

        if (fechaFinHora < 8 ) {
            alert("Hora de fin anterior a las 8:00am");
            return false;
        }

        let minutosCita= getMinutosEntreDatesSinAbs(dtFechaInicio, dtFechaFin);
        console.log("minutosCita: ", minutosCita);
        /*
        if (minutosCita < 30){
            alert("El periodo de la cita debe ser mayor o igual a media hora");
            return false;
        }
        */
        return true;
    }

    aceptar = () => {
        const {elemento} = this.state;
        const {auth, onAceptar} = this.props;
        if (this.esCitaValida(elemento))
            guardar(elemento, auth.usuarioCodigo, this.elementoConfig, onAceptar);
    }

    cancelar = () => {
        const {onCancelar} = this.props;
        onCancelar && onCancelar();
    }


    render() {
        const {elemento} = this.state;
        console.log("CITA - RENDER");
        console.log("elemento: ", elemento);
        return (
            <>
                <div className="fr_formulario">
                    {showSecciones(elemento, this.elementoConfig.secciones, this)}
                    {elemento.codigo > 0 &&
                        <button className="fr_boton refrescar" onClick={this.addSalaEspera}>A Sala de espera</button>
                    }
                    <button className="fr_boton aceptar" onClick={this.aceptar}>Aceptar</button>
                    <button className="fr_boton cancelar" onClick={this.cancelar}>Cancelar</button>
                </div>
            </>
        )
    }
}

Cita.propTypes = {
    elementoConfig: PropTypes.object,
    elemento: PropTypes.object,
    onAceptar: PropTypes.func,
    onCancelar: PropTypes.func,
}

const mapStateToProps = function(state) {
    console.log ("mapStateToProps ", state);
    return {
        auth: state.auth,
        estado: state.estado,
        datosmaestros: state.datosmaestros,
    }
}
export default connect(mapStateToProps)(Cita);



